/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AzureApiStrictHttpResponse } from '../../azure-api-strict-http-response';
import { AzureApiRequestBuilder } from '../../azure-api-request-builder';

import { VendorAuctionWorksheetAttachmentDto } from '../../models/vendor-auction-worksheet-attachment-dto';

export interface ApiVendorVendorAuctionUploadVendorAttactmentPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: Array<VendorAuctionWorksheetAttachmentDto>
}

export function apiVendorVendorAuctionUploadVendorAttactmentPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionUploadVendorAttactmentPost$Params, context?: HttpContext): Observable<AzureApiStrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>> {
  const rb = new AzureApiRequestBuilder(rootUrl, apiVendorVendorAuctionUploadVendorAttactmentPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AzureApiStrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>;
    })
  );
}

apiVendorVendorAuctionUploadVendorAttactmentPost.PATH = '/api/vendor/vendor-auction/UploadVendorAttactment';
